<template>
  <div class="page" v-if="totalPage > 1">
    <div class="page__wrap">
      <div
        class="page__prev"
        :class="preClickable ? '' : 'page__able'"
        @click="topre"
      >
        <i class="iconfont health__arrow_left"></i>
      </div>
      <div class="page__num">
        <ul>
          <li
            v-for="(item, index) in showPageList"
            :key="index"
            :class="item === '...' ? 'page__more' : ''"
          >
            <div v-if="item == '...'">
              {{ item }}
            </div>
            <div
              :class="item == currentPage ? 'common select' : 'common'"
              v-else
              @click="handleClick(item)"
            >
              {{ item }}
            </div>
          </li>
        </ul>
      </div>
      <div
        class="page__next"
        :class="nextClickable ? '' : 'page__able'"
        @click="tonext"
      >
        <i class="iconfont health__arrow_right"></i>
      </div>
      <div class="page__total">
        {{TLang('共','list')}} <span class="page__totalCount">{{ totalPage }}</span> {{TLang('页','list')}}
      </div>
      <div class="page__tonum">
        {{TLang('到第','my')}}
        <input type="number" v-model="toNum" />
        {{TLang('页','my')}}
      </div>
      <div class="page__ok" @click="ok">{{TLang('确定','home')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pagniation",
  props: {
    total: {
      type: [Number, String],
      required: true
    },
    pageSize: {
      type: [Number, String],
      default: 10 // 默认pageSize 为 10
    }
  },
  data() {
    return {
      pageStyle: {},
      showPageList: [],
      currentPage: 1,
      preClickable: false,
      nextClickable: true,
      toNum: ""
    };
  },
  created() {
    this.currentPage = 1;
  },
  methods: {
    ok() {
      if (this.toNum > this.totalPage) {
        this.handleClick(this.totalPage);
      } else if (this.toNum <= this.totalPage && this.toNum > 0) {
        this.handleClick(this.toNum);
      } else {
        this.handleClick(1);
      }
      this.toNum = "";
    },
    topre() {
      if (this.currentPage !== 1) {
        this.handleClick(this.currentPage - 1);
      }
    },
    tonext() {
      if (this.currentPage !== this.totalPage) {
        this.handleClick(this.currentPage + 1);
      }
    },
    handleClick(item) {
      this.currentPage = Number(item);
      let currentPage = this.currentPage;
      if (
        currentPage >= 6 &&
        currentPage <= this.totalPage - 3 &&
        this.totalPage > 7
      ) {
        let temp = [1, 2, "..."];
        let arr = [
          currentPage - 2,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          currentPage + 2,
          "..."
        ];
        this.showPageList = [...temp, ...arr];
      } else if (currentPage > this.totalPage - 3 && this.totalPage > 7) {
        let temp = [1, 2, "..."];
        let arr = [
          this.totalPage - 4,
          this.totalPage - 3,
          this.totalPage - 2,
          this.totalPage - 1,
          this.totalPage
        ];
        this.showPageList = [...temp, ...arr];
      } else if (currentPage <= 5 && this.totalPage > 7) {
        this.showPageList = Array.from(
          { length: 7 },
          (item, index) => index + 1
        ).concat("...");
      }
      this.$emit("current-change", item);
    }
  },
  computed: {
    totalPage: function() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  beforeUpdate() {
    // this.total = 0;
  },
  watch: {
    total() {
      this.currentPage = 1; // 默认指向第一页
      const totalPage = Math.ceil(this.total / this.pageSize);
      if (totalPage <= 7) {
        // 总页数小于7 展示
        // Array.from({length:totalPage},(item, index)=> index+1) //[...new Array(totalPage).keys()]
        this.showPageList = Array.from(
          { length: totalPage },
          (item, index) => index + 1
        );
      } else {
        this.showPageList = Array.from(
          { length: 7 },
          (item, index) => index + 1
        ).concat("...");
      }
    },
    currentPage(val) {
      if (val == 1) {
        this.preClickable = false;
      } else {
        this.preClickable = true;
      }

      if (val == this.totalPage) {
        this.nextClickable = false;
      } else {
        this.nextClickable = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 32px;
  margin-top: 24px;
  text-align: center;
  .clearfix;
  .page__wrap {
    height: 32px;
    display: inline-block;
    // float: right;
    .clearfix;
  }
  .page__able {
    color: #ccc !important;
  }
  .page__prev {
    height: 32px;
    line-height: 30px;
    border: 1px solid #e5e5e5;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    float: left;
  }

  .page__next {
    height: 32px;
    line-height: 30px;
    border: 1px solid #e5e5e5;
    border-left: none;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    float: left;
    // margin-left: 5px;
  }

  .page__prev:hover,
  .page__next:hover {
    // background: linear-gradient(130deg, @color-second 0%, @color-main 100%);
    // border-radius: 2px;
    // color: #fff;
    // border-image: linear-gradient(130deg, @color-second, @color-main) 1 1;
    color: #4285f4;
  }

  .page__able:hover {
    background: none !important;
    border-color: #e5e5e5;
  }

  .health__arrow_left {
    font-size: 24px;
    float: left;
    width: 30px;
  }
  .health__arrow_right {
    font-size: 24px;
    float: right;
    width: 30px;
  }
  .page__num {
    float: left;
    // margin-left: 10px;
    .clearfix;
  }
  .page__num ul li {
    // display: inline-block;
    float: left;
    width: 32px;
    height: 32px;
    line-height: 30px;
    color: #333;
    text-align: center;
    // margin-right: 5px;
    cursor: pointer;
  }
  .page__num ul li div {
    border: 1px solid #e5e5e5;
    border-left: none;
  }
  .page__num ul li .common:hover {
    color: #4285f4;
    // border-image: linear-gradient(130deg, @color-second, @color-main) 1 1;
  }
  .page__num ul li .select {
    width: 32px;
    height: 32px;
    // background: linear-gradient(130deg, @color-second 0%, @color-main 100%);
    // color: white;
    color: #4285f4;
    // border: none;
  }
  .page__num ul li .select:hover {
    // color: #fff;
  }
  .page__num ul .page__more div {
    // border: none;
    // line-height: 20px;
    // letter-spacing: 2px;
    height: 32px;
    line-height: 22px;
  }
  .page__num ul .page__more:hover {
    cursor: default;
    color: #333;
  }
  .page__total {
    float: left;
    line-height: 32px;
    font-size: 12px;
    color: #aab1b8;
    margin-left: 10px;
  }
  .page__totalCount {
    // color: #333;
  }
  .page__tonum {
    float: left;
    margin-left: 10px;
    line-height: 32px;
    color: #ccc;
  }
  .page__tonum input {
    width: 32px;
    height: 30px;
    outline: none;
    border: 1px solid #ccc;
    // border-color: #ccc;
    border-radius: 2px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
    text-align: center;
  }
  .page__ok {
    width: 50px;
    height: 32px;
    font-size: 14px;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    float: left;
    color: #555555;
    border: 1px solid #ccc;
    margin-left: 10px;
    border-radius: 2px;
  }
  .page__ok:hover {
    // background: linear-gradient(130deg, @color-second 0%, @color-main 100%);
    // border-radius: 2px;
    // color: #fff;
    // border: none;
    color: #4285f4;
  }
}
</style>
